import typeToReducer from 'type-to-reducer';
import { combineReducers } from 'redux';
import { enhanceWithResetActions, loadingStateReducer } from '../utils';

import {
  DELETE_USER_BY_ID,
  LOAD_USERS,
  LOAD_USERS_RESUME,
  LOAD_USERS_RESUME_WITH_FILTER,
  UPDATE_USER_BY_ID
} from './constants';

export default combineReducers({
  loadingState: loadingStateReducer(LOAD_USERS),
  updateLoadingState: enhanceWithResetActions([LOAD_USERS])(loadingStateReducer([UPDATE_USER_BY_ID])),
  deletingUserStatus: loadingStateReducer(DELETE_USER_BY_ID),
  data: typeToReducer(
    {
      [LOAD_USERS]: {
        SUCCESS: (data, { payload }) => payload
      },
      [LOAD_USERS_RESUME]: {
        SUCCESS: (data, { payload }) => payload
      },
      [LOAD_USERS_RESUME_WITH_FILTER]: {
        SUCCESS: (data, { payload }) => payload
      },
      [UPDATE_USER_BY_ID]: {
        SUCCESS: (data, { payload }) => data.map(user => (user.id === payload.id ? { ...payload } : user))
      },
      [DELETE_USER_BY_ID]: {
        SUCCESS: (data, { userId }) => data.filter(user => user.id !== userId)
      }
    },
    []
  )
});
